// extracted by mini-css-extract-plugin
module.exports = {"trialInfoBox":"BlockTrialsInfoSummary_trialInfoBox____m0e","paidTrialBox":"BlockTrialsInfoSummary_paidTrialBox__kPItL","freeTrialBox":"BlockTrialsInfoSummary_freeTrialBox__d5xCR"};